import {
  defaultLocale,
  defaultPropertyId,
  localeOptions,
  propertyOptions,
  defaultDomains,
} from '../../constants/defaultValues';

import {
  CHANGE_LOCALE,
  CHANGE_PROPERTY,
  CHANGE_DOMAINS,
  CHANGE_TIMEZONE,
  CHANGE_CURRENCY,
  CHANGE_USER,
  CHANGE_GROUP,
  USER_ROLE,
  CHECK_VOUCHER_ENGINE,
  CHANGE_CLODBEDS,
  CHANGE_CLODBEDS_CODE,
  CHECK_PIN
} from '../actions';

const INIT_STATE = {
  locale:
    localStorage.getItem('currentLanguage') &&
      localeOptions.filter(
        (x) => x.id === localStorage.getItem('currentLanguage')
      ).length > 0
      ? localStorage.getItem('currentLanguage')
      : defaultLocale,
  propertyId: localStorage.getItem('currentPropertyId') || '',
  domains: localStorage.getItem('currentDomains') || defaultDomains,
  timeZone: localStorage.getItem('timeZone') || 'Pacific/Auckland',
  currency: localStorage.getItem('currency') || 'NZD',
  email: localStorage.getItem('email') || '',
  isVoucherEngine: localStorage.getItem('isVoucherEngine') || false,
  groupId: localStorage.getItem('groupId') || '',
  userRole: localStorage.getItem('userRole') || '',
  cloudBedsId: localStorage.getItem('cloudbedsId') || '',
  cloudBedsCode: localStorage.getItem('cloudbedsCode') || '',
  checkPin: localStorage.getItem('checkPin') || false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return { ...state, locale: action.payload };

    case CHANGE_PROPERTY:
      return { ...state, propertyId: action.payload };

    case CHANGE_DOMAINS:
      return { ...state, domains: action.payload };

    case CHANGE_TIMEZONE:
      return { ...state, timeZone: action.payload };

    case CHANGE_CURRENCY:
      return { ...state, currency: action.payload };

    case CHANGE_USER:
      return { ...state, email: action.payload };
    case USER_ROLE:
      return { ...state, userRole: action.payload };
    case CHECK_VOUCHER_ENGINE:
      return { ...state, isVoucherEngine: action.payload };
    case CHANGE_GROUP:
      return { ...state, groupId: action.payload };
    case CHANGE_CLODBEDS:
      return { ...state, cloudBedsId: action.payload };

    case CHANGE_CLODBEDS_CODE:
      return { ...state, cloudbedsCode: action.payload };

    case CHECK_PIN:
        return { ...state, checkPin: action.payload };

    default:
      return { ...state };
  }
};
